function t(r){if(!r)return"";let e=r.toString();return e=e.replace("&gt;",">").replace("&lt;","<").replace("&amp","&").replace("&#34;",'"').replace("&#39","'"),e.replace(/(<([^>]+)>)/gi,"")}export{t as s};
//# sourceMappingURL=stripTags-es.js.map
